import { put, select, takeLatest } from 'redux-saga/effects'
import { CustomSignaturesConstants } from '../store/customSignature.constants'
import { getCustomSignaturesSelector } from '../selectors/getCustomSignature.selectors'
import { ICustomFormsSignatureState } from '../store/customSignature.types'
import { ISignatureOptionsState } from '../../options/store/options.types'
import { getSignatureOptionsSelector } from '../../options/selectors'
import { setCustomAcknowledgePrivacyNotice, setCustomSignatureTerm } from '../store/customSignature.actions'
import Logger from '../../../services/logger.service'
import { updateSignatureTerms } from '../../../utilities/signaturesTermConversion.util'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { getTripInformationSelector } from '../../tripInformation/selectors'

export function* setTermsData() {
  try {
    const customSignature: ICustomFormsSignatureState = yield select(getCustomSignaturesSelector)
    const { customSignatureClientData } = customSignature
    const { currentSelectedOption, acknowledgedPrivacyNotices } = customSignatureClientData
    const signatureOptionsState: ISignatureOptionsState = yield select(getSignatureOptionsSelector)
    const { customSignatureTranformedOptions } = signatureOptionsState
    const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
    const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
    let term = ''

    customSignatureTranformedOptions.forEach((option) => {
      if (option.id === currentSelectedOption?.parentID) {
        term = option.text
      }
    })

    const updatedTerm = updateSignatureTerms(term, patientDemographics, tripInformation)

    yield put(setCustomSignatureTerm(updatedTerm))
    if (acknowledgedPrivacyNotices.includes(currentSelectedOption?.parentID)) {
      yield put(setCustomAcknowledgePrivacyNotice(true))
    } else {
      yield put(setCustomAcknowledgePrivacyNotice(false))
    }
  } catch (e) {
    Logger.error(`setTermsData() error: ${e}`)
  }
}
export function* setTermsDataSaga() {
  yield takeLatest([CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_CURRENT_SELECTED_OPTION], setTermsData)
}
